export default {
  sourcesLabel: { id: 'rm_footer_sources_label', defaultMessage: 'Sources' },
  contributorsLabel: {
    id: 'rm_footer_contributors_label',
    defaultMessage: 'Contributors',
  },
  pressKitLabel: {
    id: 'rm_footer_press_kit_label',
    defaultMessage: 'Press kit',
  },
} as const
